import React, { useState, useEffect } from "react";
import Header from "../../component/loaderComponent/Header/Header";
import Sidebar from "../Sidebar";
import './createrole.scss';
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { CreateRoleAction, RoleNameAction, PermissionAction } from "../../actions/RoleAction";
import { notify } from '../../services/notification';
import { HiMenu, HiX } from "react-icons/hi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import useMobileView from "../../constants/useMobileView";


function CreateRole() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setloading] = useState(false);
    const [supervisers, setSupervisers] = useState([]);
    const {  isSidebarOpen, toggleSidebar } = useMobileView();

    const [permissions, setPermissions] = useState([]);
    const [states, setStates] = useState({
        role: "",
        reports_to_id: "",
        is_root: false,
        permission_ids: Array(),
        roleError: ""
    })

    const handleInput = (e) => {
        let key = e.target.name;
        let value = e.target.value;
        let error = "";

        if (key === "role") {
            if (value.length < 3) {
                error = "Role name must be at least 3 characters long";
            } else if (value.length > 25) {
                error = "Role name can not exceed 25 characters";
            }
        }

        if (key === "permission_ids") {
            let checked = e.target.checked;
            if (checked || states[key].length === 0) {
                let arr = [...states.permission_ids]
                setStates({ ...states, [key]: [...arr, Number(value)], roleError: error })
            } else {
                let arr = [...states.permission_ids].filter((val) => val !== Number(value))
                setStates({ ...states, [key]: [...arr], roleError: error })
            }
        } else if (key === "reports_to_id") {
            setStates({ ...states, [key]: Number(value), roleError: error })
        } else {
            setStates({ ...states, [key]: value, roleError: error })
        }
    }

    async function GetRoleNameData() {
        setloading(true);
        var response = await dispatch(RoleNameAction());
        if (response?.status === 200) {
            setloading(false);
            setSupervisers(response?.data?.results?.data);
        } else if (response === undefined) {
            setloading(false);
        }
    }

    async function GetPermissionsData() {
        setloading(true);
        var response = await dispatch(PermissionAction());
        if (response?.status === 200) {
            setloading(false);
            setPermissions(response?.data?.data);
        } else if (response === undefined) {
            setloading(false);
        }
    }

    useEffect(() => {
        GetPermissionsData()
        GetRoleNameData()
    }, []);

   

    const handleOnSaveClick = async (e) => {
        e.preventDefault();
        setloading(true);
        if (states.roleError === "") {
            let response = await dispatch(CreateRoleAction(states));
            if (response?.status === 200) {
                notify.success(response.data.message)
                setloading(false);
                navigate("/rolemanagement")
            } else if (response?.status === 400) {
                notify.error(response?.data?.error?.role)
                setloading(false);
            } else if (response === undefined) {
                setloading(false);
            }
        } else {
            notify.error(states.roleError);
            setloading(false);
        }
    }
    
    const CancelRole = (evt) => {
        navigate('/rolemanagement')
    }

    return (
        <div className="create-role-container">
              <div className="role-header">
        <button className="role-hamburger-button" onClick={toggleSidebar}>
          {isSidebarOpen ? (
            <HiX className="role-icon" size={24} />
          ) : (
            <HiMenu className="role-icon" size={24} />
          )}
        </button>
      </div>

      {/* Sidebar Overlay */}
      <div
        className={`role-overlay ${isSidebarOpen ? 'active' : ''}`}
        onClick={toggleSidebar}
      ></div>
            <div className="create-role-main">
                <Header title="Create Role" />
                {loading ? <Loader /> :
                    <form onSubmit={handleOnSaveClick}>
                        <div className="create-role-input-checkbox">
                            <div className="create-role-check-box">
                                <div className="create-role">
                                    <label className="lable-create-role">Role Name</label>
                                    <input className="create-role-input-field"  value={states.role} type="text" onChange={handleInput} name="role" />
                                </div>
                                <div className="create-role">
                                    <label></label>
                                    <div className="error-message-create-role">
                                    {states.roleError && (
                                        <span className="error-message-role">{states.roleError}</span>
                                    )}
                                    </div>
                                </div>
                                <div className="create-role">
                                    <label className="lable-create-role">Permissions</label>
                                </div>
                                <div className="create-role">
                                    <div className="create-role-checkbox-container">
                                        {
                                            permissions.length > 0 && permissions.map((val) =>
                                                <div className="create-role-checkbox" key={val.id}>
                                                    <input className="creates-role-checkbox" type="checkbox" name="permission_ids" checked={states.permission_ids.length > 0 && states.permission_ids.some((i) => i === val.id) ? true : false} value={val.id} onChange={handleInput} />
                                                    <label className="creates-roles-label">{val?.permission}</label>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="create-role">
                                    <label className="lable-create-role">Reports To</label>
                                </div>
                                <div className="create-role">
                                    <div className="create-role-checkbox-container">
                                        {
                                            supervisers.length > 0 && supervisers.map((val) =>
                                                <div className="create-role-checkbox" key={val.id}>
                                                    <input className="creates-role-checkbox" type="radio" checked={states?.reports_to_id === val.id ? true : false} name="reports_to_id" value={val.id} onChange={handleInput} />
                                                    <label className="creates-roles-label">{val?.role}</label>
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                                <div className="create-role-button">
                                    <button className="create-role-cancel-button" onClick={CancelRole}
                                    >Cancel</button>
                                    <button className="create-role-save-button"
                                        disabled={states.role.length < 3 || !states.role || states.permission_ids.length === 0 || !states.reports_to_id || states.roleError}
                                        type="submit">Save</button>
                                </div>
                            </div>
                        </div>
                    </form>
                }
            </div>
        </div>
    )
}
export default CreateRole;